/**
 * React component that is responsible for interpretting section blocks
 *  and return the appropiate component to render.
 *
 * Copyright (c) 2020 Coursera
 * Author: Kelvin Nguyen
 */
import React from 'react'
import PropTypes from 'prop-types'
import ContentfulSection from './ContentfulSection'
import ContentfulManifesto from './ContentfulManifesto'
import ContentfulCarousel from './ContentfulCarousel'
import ContentfulSimpleText from './ContentfulSimpleText';

export const SectionBlock = ({ section }) => {
  if (!section) return null;

  const contentType = section.__typename;

  switch (contentType) {
    case 'ContentfulManifesto':
      return <ContentfulManifesto {...section} />;
    case 'ContentfulSection':
      return <ContentfulSection {...section} />;
    case 'ContentfulCarousel':
      return <ContentfulCarousel {...section} />;
    case 'ContentfulSimpleTextModule':
      return <ContentfulSimpleText {...section} />;
    default:
      return null;
  }
};

SectionBlock.propTypes = {
  section: PropTypes.object,
};

export default ({ sectionBlocks = [] }) => (
  sectionBlocks.map((section) => (
    <SectionBlock key={section.id} section={section} />
  ))
)
